<template>
  <DashboardChartWrapper
    title="Ventes par statut"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Doughnut v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(ArcElement, Tooltip, Legend)

const labelMap = {
  pending: 'En attente',
  partial_paid: 'Partiellement paye',
  paid: 'Paye',
  completed: 'Termine',
  refunded: 'Rembourse',
  partial_refund: 'Remb. partiel'
}

const colorMap = {
  pending: '#f59e0b',
  partial_paid: '#3b82f6',
  paid: '#10b981',
  completed: '#059669',
  refunded: '#ef4444',
  partial_refund: '#f97316'
}

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/charts/sales-by-status', dateParams)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => labelMap[d.label] || d.label),
    datasets: [{
      data: data.value.map(d => d.count),
      backgroundColor: data.value.map(d => colorMap[d.label] || '#6b7280'),
      borderWidth: 2,
      borderColor: '#fff'
    }]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '60%',
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16 } }
  }
}
</script>
